import { Hidden, Table, TableBody } from "@material-ui/core";
import { useMemo } from "react";
import CssPagination from "src/components/Pagination/CssPagination";
import usePagination from "src/hooks/usePagination";
import DesktopTransactionRow from "./DesktopTransactionRow";
import SmallTransactionRow from "./SmallTransactionRow";
import TransactionTableHeader from "./TransactionTableHeader";

export default function TransactionHistoryTable({ dataTable, pool, isFullTable = true }) {
  const sortDataTable = useMemo(() => {
    return dataTable.sort((a, b) => b.timestamp - a.timestamp);
  }, [dataTable]);
  const { data, jump, maxPage, currentPage } = usePagination(sortDataTable);

  return (
    <>
      <Table>
        <TransactionTableHeader isFullTable={isFullTable} />
        <TableBody>
          {data.map((element) => {
            return (
              <>
                <Hidden mdDown>
                  <DesktopTransactionRow rowData={element} pool={pool} isFullTable={isFullTable} />
                </Hidden>
                <Hidden lgUp>
                  <SmallTransactionRow rowData={element} pool={pool} isFullTable={isFullTable} />
                </Hidden>
              </>
            );
          })}
        </TableBody>
      </Table>
      {sortDataTable.length > 0 && (
        <CssPagination
          mt={1}
          paginationProps={{ page: currentPage, count: maxPage, onChange: (_, page) => jump(page) }}
        />
      )}
    </>
  );
}
